import { useQuery } from '@tanstack/react-query';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { IHealthcareProfessional } from '../HealthcareProfessional.ts';

export function useGetHealthcareProfessionalsByFacility(facilityId: number | null) {
    return useQuery<IHealthcareProfessional[]>({
        queryKey: ['healthcareProfessionalsByFacility', facilityId],
        queryFn: () => HealthcareProfessionalsApi.getByFacilityId(facilityId!),
        enabled: !!facilityId,
    });
}
